import { render, staticRenderFns } from "./Presentation.vue?vue&type=template&id=238aa82e&scoped=true"
import script from "./Presentation.vue?vue&type=script&lang=js"
export * from "./Presentation.vue?vue&type=script&lang=js"
import style0 from "./Presentation.vue?vue&type=style&index=0&id=238aa82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238aa82e",
  null
  
)

export default component.exports